import { Routes } from '@angular/router';
import { GENERAL_ROUTES_WITH_PERMISSIONS } from './app.routes';

export default GENERAL_ROUTES_WITH_PERMISSIONS satisfies Routes;
